import { NgModule } from '@angular/core';

import { ImgServiceDirective } from './img.service.directive';

/**
 * The ImgServiceDirectiveModule module
 */
@NgModule({
    declarations: [
        ImgServiceDirective
    ],
    imports: [],
    exports: [
        ImgServiceDirective
    ]
})
// tslint:disable-next-line:no-unnecessary-class
export class ImgServiceDirectiveModule {}
